import { useQuery } from "@apollo/client";
import { queryfunctionForTax } from "../../../../Pages/SalesBillSetup/Tax/Tax";
import { useEffect, useMemo, useState } from "react";
import useProcessData from "../../../../../CommonFunction/ProcessData";
import { LoadTable } from "../../..";
import Reactportal from "../../../Reactportal/Reactportal";
import PortalFooter from "../../../Reactportal/PortalFooter";
import { useSelector } from "react-redux";
import { SuccessToast, WarningToast } from "../../../ToastComponent/RectHotToast";
import { useDispatch } from "react-redux";
import { useModalContext } from "../../../Reactportal/ModalContext";


interface TaxSelectionProps {
    show: boolean;
    setShowTax: () => void;
    setTaxType: (Str: string) => void;
    SelectedTaxes: Array<any>
}

export const TaxSelection: React.FC<TaxSelectionProps> = ({ show, setShowTax, setTaxType, SelectedTaxes }) => {
    const { pushModal, popModal } = useModalContext();
    const Form_Key = "TaxSelection"
    const [toggle, setToggle] = useState(show)
    const [TaxData, setTaxData] = useState([])
    const [selectedRow, setSelectedRow] = useState([])
    const dispatch = useDispatch()
    const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
    const { loading: queryLoading, error, data } = useQuery(queryfunctionForTax([

        "_id", "Unique_Id", "Tax_Name", "Tax_Type", "Tax_Rate"
    ]), {
        fetchPolicy: "network-only",

    });
    useEffect(() => {
        pushModal(Form_Key);
        return () => {
            popModal(Form_Key)
        }
    }, []);

    useEffect(() => {
        setSelectedRow(SelectedTaxes)
    }, [])
    const config = useMemo(
        () => ({
            dataKey: "getAllTax",
            //   dateKeys: ["createdAt", "updatedAt"],
            deleteKeys: ["is_Audit", "__typename"],
        }),
        []
    );


    const Submit = () => {
        let SelectedRows = fielddataRedux?.Select_Tax?.Selected_Rows;
        const cgst = SelectedRows.filter(tax => tax.Tax_Type.startsWith("CGST"));
        const sgst = SelectedRows.filter(tax => tax.Tax_Type.startsWith("SGST"));
        const igst = SelectedRows.filter(tax => tax.Tax_Type.startsWith("IGST"));
        const exempt = SelectedRows.filter(tax => tax.Tax_Type.startsWith("exempt"));
        console.log(cgst, sgst, "csgst", exempt, igst, cgst.length > 0 && sgst.length > 0)
        if (exempt.length) {
            Closeformfunction()
            return
        }
        const validGSTRates = [5, 12, 18, 28]; // Standard GST rates

        // Validate IGST independence
        if (igst.length > 0 && (cgst.length > 0 || sgst.length > 0)) {
            setTaxType("")
            WarningToast("You cannot group IGST with CGST and/or SGST.");
            return { isValid: false, message: "You cannot group IGST with CGST and/or SGST as it applies independently to inter-state sales.", groupType: null };
        }

        // Validate CGST and SGST grouping
        console.log(cgst.length > 0 && sgst.length > 0, "csgst1", cgst, sgst)
        if (cgst.length > 0 && sgst.length > 0) {
            console.log(cgst, sgst, "csgst")
            const totalStateGST = cgst.reduce((acc, cur) => acc + parseFloat(cur.Tax_Rate), 0) +
                sgst.reduce((acc, cur) => acc + parseFloat(cur.Tax_Rate), 0);
            if (!validGSTRates.includes(totalStateGST)) {
                console.log("gst")
                setTaxType("GST")
                WarningToast(`The sum of CGST and SGST must align with a standard GST rate: ${validGSTRates.join(", ")}%.`);
                return { isValid: false, message: `The sum of CGST and SGST must be one of the standard GST rates: ${validGSTRates.join(", ")}%.`, groupType: "GST" };
            } else {
                console.log("gst")
                setTaxType("GST")
                SuccessToast("Tax group is valid for GST.");
                Closeformfunction();
                return { isValid: true, message: "Tax group is valid for GST.", groupType: "GST" };
            }
        }

        // Cases where either CGST or SGST is selected alone
        if ((cgst.length > 0 && sgst.length === 0) || (cgst.length === 0 && sgst.length > 0)) {
            setTaxType("")
            WarningToast("CGST and SGST must be selected together and their sum must align with a standard GST rate.");
            return { isValid: false, message: "CGST and SGST must be selected together and their sum must align with a standard GST rate.", groupType: null };
        }

        // If IGST alone
        if (igst.length > 0) {
            setTaxType("IGST")
            SuccessToast("Tax group is valid for IGST.");
            Closeformfunction();
            return { isValid: true, message: "Tax group is valid for IGST.", groupType: "IGST" };
        }
        setTaxType("")
        // No valid tax type detected
        WarningToast("Please select appropriate tax types.");
        return { isValid: false, message: "No valid tax group detected. Please select appropriate tax types.", groupType: null };
    }

    const Closeformfunction = () => {
        setShowTax()
        setToggle(false)
    }
    const ClearFun = () => {
        const payloadData = {
            key: "Select_Tax", data: {
                Selected_Rows: []
            }
        };
        dispatch({ type: "UNIQUE_TABLE_LIST", payload: payloadData });
        Closeformfunction()

    }
    const { loading: processDataLoading } = useProcessData(data, setTaxData, config, error);

    return <>
        <Reactportal open={toggle} onClose={ClearFun} TypeOfPortal={"Select Tax"}>
            <LoadTable dragDrop={false} title={"Select_Tax"} data={TaxData} loading={queryLoading} error={error}
                selectedRows={selectedRow}
            />
            <PortalFooter
                renderContent={() => <></>}
                disabled={false}
                Form_key={Form_Key}
                TypeOfPortal={"Edit"}

                SaveAndClose={() => console.log(Submit(), "Subbbbbbbbbbb")}
                handleformclose={() => {
                    ClearFun()
                }}

            />
        </Reactportal>
    </>
}